export const DownArrowButton = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="20"
    viewBox="0 0 64 64"
    style={{ filter: "drop-shadow(0px 2px 6px rgba(0,0,0,0.2))" }}
  >
    <circle cx="32" cy="32" r="30" fill="white" />

    <path
      d="M22 26 L32 38 L42 26"
      stroke="#f97316"
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);